import React from 'react';
import ReactDOM from 'react-dom';
import { Provider } from 'react-redux';
import configureStore from 'store/configureStore';
import Router from 'components/router';
import * as serviceWorker from 'registerServiceWorker';
import { GlobalStyle } from 'styles/global';
import { consoleLogger } from 'helpers';

/* for aws amplify */
import clientConfig from 'clientConfig';
import { 
  GetAmplifyAuthConfig,
  GetAmplifyStorageConfig
} from 'awsConfig';
import Amplify from 'aws-amplify';

// ストアの生成
const store = configureStore();
ReactDOM.render(
  <Provider store={store}>
    <Router />
    <GlobalStyle />
  </Provider>,
  document.getElementById('react-root')
);

// Authの構築
try {
  Amplify.configure({
    Auth: GetAmplifyAuthConfig(clientConfig['client_id']),
    Storage: GetAmplifyStorageConfig()
  });
} catch (err) {
  consoleLogger('index-Amplify.configure-catch', err);
}
// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: http://bit.ly/CRA-PWA
serviceWorker.unregister();